import { render } from "./FileButtonsGroup.vue?vue&type=template&id=33900da6&bindings={\"file\":\"props\",\"store\":\"setup\",\"copyUrl\":\"setup\",\"copyCode\":\"setup\",\"location\":\"setup\",\"deleteFile\":\"setup\",\"updateFile\":\"setup\"}"
import script from "./FileButtonsGroup.vue?vue&type=script&lang=js"
export * from "./FileButtonsGroup.vue?vue&type=script&lang=js"
script.render = render

export default script